import React from 'react'
import { useTranslation } from 'react-i18next';
import AlertModal from '../../pages/Modals/AlertModal';

function ModalNoMetamask({open, onClose}) {
    const {t}=useTranslation();

    const handleInstall = () => {
        var win = window.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en', '_blank');
        win.focus();
        onClose();
    };

  return (
    <AlertModal
      open={open}
      onClose={onClose}
      onConfirm={handleInstall}
      variant="info"
      message="In order to use this application, you need to install Metamask wallet."
      confirmLabel="Install Metamask"
    />
  )
}

export default ModalNoMetamask;